import HTMLtoDOCX from 'html-to-docx';
// import juice from 'juice';
// const css = require('!!raw-loader!../assets/css/glasnik.css');

export async function exportHtmlToWork(html, title = 'download') {
    console.log(title);
    const fileBuffer = await HTMLtoDOCX(html, null, {
        table: { row: { cantSplit: true } },
        footer: true,
        pageNumber: true,
    })

    //const juiceHtml = juice.inlineContent(fileBuffer.text(), css);
    const blobUrl = URL.createObjectURL(fileBuffer)
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = `${title}.docx`;

    link.click();
    URL.revokeObjectURL(blobUrl);
}

export function exportBlobToPdf() {
    //const blob = new Blob([data], { type: 'application/pdf' });
}

export function changeImageSrc(content, url, id) {
    //izvnacimo sve slike u content-u
    const tempElement = document.createElement('div');
    tempElement.innerHTML = content;
    const imgElements = tempElement.querySelectorAll('img');
    // pravimo kompiju content-a da bismo u njoj izmenili to sto nam treba
    const clonedTempElement = tempElement.cloneNode(true);

    //za svaku sliku, pronalazimo ime slike(src), pronalazimo taj element u content kopiji i menjamo mu src
    imgElements.forEach((element) => {
        const src = element.getAttribute('src');
        const originalImg = clonedTempElement.querySelector('img[src="' + element.getAttribute('src') + '"]');
        originalImg.src = url + src + `?actId=${id}`;
    });
    // na kraju ceo taj novokreirani, klonirani content zalepimo na postojeci
    return clonedTempElement.innerHTML;
}

export function hasAllValues(mainArray, valuesToCheck) {
    mainArray.sort((a, b) => a - b); // Sort the main array

    // Use binary search for each value in valuesToCheck
    return valuesToCheck.every(value => mainArray.includes(value));
}

export function containsOnlyNumbers(myString) {
    return /^\d+$/.test(myString);
}

export function adjustHtmlContent(content) {
    return content.replace(/&gt;/g, '>').replace(/^http:/, 'https:').replace(/glasnik.css/, window.env.VUE_APP_API_REG_DEV + 'glasnik.css');
}

export function attachIframeEventListener() {
    const iframe = document.querySelector('iframe');
    if (iframe) {
        // Add event listener to the iframe content window
        iframe.addEventListener('load', () => {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            if (iframeDoc) {
                iframeDoc.querySelectorAll('a[href^="#"]').forEach(anchor => {
                    anchor.addEventListener('click', event => {
                        event.preventDefault();
                        const targetId = event.target.getAttribute('href').substring(1); // Remove leading '#'
                        const targetElement = iframeDoc.getElementById(targetId);
                        if (targetElement) {
                            // Scroll to the target element within the iframe
                            targetElement.scrollIntoView({ behavior: 'smooth' });
                        }
                    });
                });
            }
        });
    }
}

export function changeLinks() {
    const iframe = document.querySelector('iframe');
    if (iframe) {
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

        // Add event listener to all <a> tags inside the iframe
        const anchorTags = iframeDocument.querySelectorAll('a');
        anchorTags.forEach(anchor => {
            anchor.addEventListener('click auxclick', (e) => {
                if (e.target.href.includes("/viewdoc")) {
                    e.target.href = e.target.href.substr(e.target.href.indexOf("/viewdoc"));
                }
                if (e.target.href.includes("/eli")) {
                    e.target.href = e.target.href.substr(e.target.href.indexOf("/eli"));
                }
            });
        });
    }
}

export function EventListenerForDownloadAndPrintDoc(self) {
    window.addEventListener("keydown", function(event) {
        if (event.ctrlKey && event.keyCode === 83 && self.userInfoState) {
          event.preventDefault();
          self.linkForDownload.download = "document.pdf";
          self.linkForDownload.click();
        } else event.preventDefault();
        if (event.ctrlKey && event.keyCode === 80 && self.userInfoState) {
          event.preventDefault();
          var iframe = document.createElement("iframe");
          document.body.appendChild(iframe);
  
          iframe.style.display = "none";
          iframe.src = self.srcUrl;
          iframe.onload = function() {
            setTimeout(function() {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        } else event.preventDefault();
      });
    }